// src/client/task-types/base.js

const requestAce = async (...args) => (await import(/* webpackPreload: true, webpackChunkName: "chunk-ace" */ 'client/ace')).default(...args);
const requestBaseTask = () => import(/* webpackChunkName: "chunk-htmlacademy-task" */ 'client/htmlacademy-task');

const requestOldMultifileTask = () => import(/* webpackChunkName: "chunk-old-htmlacademy-multi-file-task" */ 'client/htmlacademy-multi-file-task');
const requestMultifileTask = () => import(/* webpackChunkName: "chunk-mf--htmlacademy-task" */ 'client/mf--htmlacademy-task');

const requestDummy = () => Promise.resolve({'default': () => null});

module.exports = {
  requestAce,
  requestBaseTask,
  requestOldMultifileTask,
  requestMultifileTask,
  requestDummy,
};
